<template>
    <el-dialog
        title="历史上传"
        :visible.sync="dialogVisible"
        width="1200px" class="historyUploadDialogBox">
        <div class="historyUploadDialog">
            <div class="historyUploadHeader">
                <div class="fileImage">3D文件展示</div>
                <div class="name">名称</div>
                <div class="size">尺寸(cm)</div>
                <div class="size">体积(cm<sup>3</sup>)</div>
                <div class="size">缩放(%)</div>
                <div class="operation">操作</div>
            </div>
            <div class="historyUploadTable" v-loading="loading">
                <el-scrollbar style="height: 500px">
                    <div class="tableItem" v-for="(item,index) in historyUploadList" :key="index" v-if="historyUploadList.length > 0">
                        <div class="fileImage">
                            <img class="snapshot" v-if="base64img" :src="base64img" />
                            <!-- <model-stl :src="item.url"></model-stl> -->
                            <model-stl ref="model" v-if="item.url.substr(item.url.lastIndexOf('.') + 1) == 'stl' || item.url.substr(item.url.lastIndexOf('.') + 1) == 'STL'" :src="item.url"  :rotation="rotation"></model-stl>
                            <model-obj ref="model" v-if="item.url.substr(item.url.lastIndexOf('.') + 1) == 'obj' || item.url.substr(item.url.lastIndexOf('.') + 1) == 'OBJ'" :src="item.url"  :rotation="rotation"></model-obj>
                        </div>
                        <div class="name">{{item.name}}</div>
                        <div class="size">{{item.longSize}} * {{item.widthSize}} * {{item.heightSize}}</div>
                        <div class="size">{{item.volume}}</div>
                        <div class="size">{{item.scale}}</div>
                        <div class="operation">
                            <el-button type="text" @click="toPrint(item)">打印</el-button>
                            <el-button type="text" @click="deleteHistoryUpload(item.uuid)">删除</el-button>
                        </div>
                    </div>
                    <div style="text-align: center;padding-top: 50px;" v-if="!loading&&historyUploadList.length <= 0">暂无历史上传</div>
                </el-scrollbar>
            </div>
        </div>
        <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total" class="pagination">
        </el-pagination>
    </el-dialog>
    <!-- 3D预览 -->
    <!--<three-d
            ref="threeBox"
            :innerVisible="innerVisible"
            :fileListNew="fileListNew"
            @closeDlog="closeDlog"
    ></three-d>-->
</template>

<script>
import { getHistoryList,deleteHistory } from '../../utils/interface';
import threeD from "../threeD/index";
import { ModelStl, ModelObj } from "vue-3d-model";
export default {
    name: "historyUpload",
    data(){
        return{
            dialogVisible: false,
            historyUploadList: [],
            current:1,
            pageSize:10,
            total:0,
            type: '',
            technologyValue: '',
            materialValue: '',
            isHollow: '',
            // 3D预览
            fileListNew: [],
            innerVisible: false,
            rotation: {
                // x: -Math.PI / 2,
                // y: 0,
                // z: 0,
                x: 200,
                y: 0,
                z: 100,
            },
            base64img:'',
            loading: true,
        }
    },
    components: {
        threeD,
        ModelStl,
        ModelObj,
    },
    mounted(){
        // this.snapshot()
    },
    methods: {
        // 分页
        handleCurrentChange(val){
            this.current = val;
            window.scrollTo(0,0);
            this.getHistoryList();
        },
        init(type,technologyValue,materialValue,isHollow){
            this.dialogVisible = true;
            this.type = type;
            this.technologyValue = technologyValue;
            this.materialValue = materialValue;
            this.isHollow = isHollow;
            this.getHistoryList();
        },
        getHistoryList(){
            this.loading = true;
            let params = {
                current:this.current,
                pageSize:this.pageSize,
                survival:"ENABLE"
            };
            getHistoryList(params).then((res)=>{
                this.historyUploadList = res.list;
                this.loading = false;
                this.current = res.current;
                this.total = res.total;
            });
        },
        // 历史上传删除
        deleteHistoryUpload(uuid){
            let params = {
                uuid:uuid
            };
            deleteHistory(params).then((res)=>{
                if(res.success){
                    this.$message.success('删除成功');
                    this.getHistoryList();
                }
            });
        },
        // 历史上传打印
        toPrint(val){
            if(this.type === 'index'){
                if(this.technologyValue && this.materialValue && this.isHollow){
                    this.dialogVisible = false;
                    this.$emit('historyToPrint',val)
                } else {
                    this.$message.warning('请先选择工艺/材料/填充，再上传3D打印模型哦~')
                }
            } else{
                this.dialogVisible = false;
                this.$emit('historyToPrint',val)
            }
        },
        // snapshot() {
        //     this.base64img = this.$refs.model[0].renderer.domElement.toDataURL('image/png', 1);
        // },
    }
}
</script>

<style scoped lang="less">
.historyUploadDialog {
    .historyUploadHeader {
        display: flex;
        height: 54px;
        background: rgba(0, 0, 0, .02);
        line-height: 54px;
        font-weight: 400;
        color: #000000;
        font-size: 14px;
        padding: 0 24px;
    }
    
    .tableItem {
        padding: 24px;
        display: flex;
        border-bottom: 1px dashed #ddd;
        align-items: center;
    }
    
    /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .fileImage{
        width: 120px;
        text-align: center;
        padding: 0 10px;
        position: relative;
        &:hover{
            .model{
                display: block;
            }
        }
        img{
            width: 98px;
            height: 98px;
        }
        .model{
            position: absolute;
            left: 21px;
            top: 0;
            width: 98px;
            height: 98px;
            background: rgba(0,0,0,.3);
            text-align: center;
            line-height: 94px;
            display: none;
            i{
                color: #fff;
                cursor: pointer;
                font-size: 20px;
            }
        }
    }
    .name {
        text-align: center;
        flex: 1;
    }
    .size {
        width: 150px;
        text-align: center;
    }
    .operation {
        width: 180px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/print/historyUpload.vue